export type RouteKey =
  | 'TeamDashboard'
  | 'TeamSetup'
  | 'TeamAccessManagement'
  | 'TeamIntegration'
  | 'TeamScheduling'
  | 'PublicSurveyResults'
  | 'PublicSurveyActionPlan';

const routerMap: Record<RouteKey, string> = {
  TeamDashboard: '/dashboard',
  TeamSetup: '/teams/{{id}}/setup',
  TeamAccessManagement: '/teams/{{id}}/access-management',
  TeamIntegration: '/teams/{{id}}/integration',
  TeamScheduling: '/teams/{{id}}/scheduling',
  PublicSurveyResults: '/results/{{id}}',
  PublicSurveyActionPlan: '/results/{{id}}/action-plan',
};

interface RouterUtils {
  getRoute(route: RouteKey, id: string): string | null;
}

export class RouterUtilsImpl implements RouterUtils {
  constructor() {}

  public getRoute(route: RouteKey, id: string): string {
    if (!this.doesRouteExist(route)) {
      return '';
    }
    return this.replaceWildcard(route, id);
  }

  private doesRouteExist(route: RouteKey): boolean {
    return Boolean(routerMap[route]);
  }

  private replaceWildcard(route: RouteKey, id: string): string {
    return routerMap[route].replace('{{id}}', id);
  }
}
